/** localStorage that never throws. Some browsers (private mode, in-app browsers, strict privacy settings) block it;
 *  we then fall back to memory so the app keeps working for the current visit. */
const mem = new Map();
export const store = {
  get(key) { try { const v = window.localStorage.getItem(key); return v === null ? (mem.get(key) ?? null) : v; } catch { return mem.get(key) ?? null; } },
  set(key, value) { mem.set(key, String(value)); try { window.localStorage.setItem(key, String(value)); } catch { /* memory only */ } },
  remove(key) { mem.delete(key); try { window.localStorage.removeItem(key); } catch { /* memory only */ } },
};
